// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202610191004/js/" + chunkId + "." + {"44":"cbf6566b","225":"aa77b8ce","481":"3dff2ffc","486":"d0bcc2bf","770":"e285a234"}[chunkId] + ".0.7940061487506989.chunk.js";
};